import * as React from "react";
const SvgClose = props => <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" {...props}><path id="Close_Icon" d="M1,1 17,17 M17,1 1,17" stroke="currentcolor" strokeWidth="2px" /></svg>;
export default SvgClose;